import { create } from 'zustand';
import { authAPI, subscriptionAPI } from '../utils/api';

const useAuthStore = create((set, get) => ({
  user: null,
  token: localStorage.getItem('pdfedit_token'),
  isLoading: true,
  subscription: null,

  // Initialize - check if token exists and fetch user
  initialize: async () => {
    const token = localStorage.getItem('pdfedit_token');
    if (!token) {
      set({ isLoading: false });
      return;
    }
    try {
      const { data } = await authAPI.getMe();
      const subRes = await subscriptionAPI.getStatus();
      set({ user: data.user, subscription: subRes.data, isLoading: false });
    } catch {
      localStorage.removeItem('pdfedit_token');
      set({ user: null, token: null, isLoading: false });
    }
  },

  // Login
  login: async (email, password) => {
    const { data } = await authAPI.login({ email, password });
    localStorage.setItem('pdfedit_token', data.token);
    set({ user: data.user, token: data.token });
    // Fetch subscription status
    try {
      const subRes = await subscriptionAPI.getStatus();
      set({ subscription: subRes.data });
    } catch {}
    return data;
  },

  // Register
  register: async (name, email, password) => {
    const { data } = await authAPI.register({ name, email, password });
    localStorage.setItem('pdfedit_token', data.token);
    set({ user: data.user, token: data.token });
    try {
      const subRes = await subscriptionAPI.getStatus();
      set({ subscription: subRes.data });
    } catch {}
    return data;
  },

  // Logout
  logout: () => {
    localStorage.removeItem('pdfedit_token');
    set({ user: null, token: null, subscription: null });
  },

  // Update user in store
  updateUser: (userData) => {
    set({ user: { ...get().user, ...userData } });
  },

  // Check if user has access
  hasAccess: () => {
    const sub = get().subscription;
    return sub?.hasAccess || false;
  }
}));

export default useAuthStore;
